/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { getRequest } from "utils/request";
import { CircularProgress } from "@material-ui/core";
import { putRequest } from "utils/request";
import { i18n } from '../../../../translate/i18n';


import '../style.css'
import ChatPreview from "./ChatPreview";
// import { useModal } from "hooks/modal";
import { toast } from "react-toastify";
import { useModal } from "hooks/modal";

export default function TabChat({ companyData, handleGoBack }) {
  const [code, setCode] = useState("");
  const [defaultColor, setDefaultColor] = useState("#000000");
  const [backgroundColorChat, setBackgroundColorChat] = useState("#000000");
  const [backgroundColorUserAnswer, setBackgroundColorUserAnswer] = useState(
    "#000000"
  );
  const [
    backgroundColorCompanyAnswer,
    setBackgroundColorCompanyAnswer,
  ] = useState("#000000");
  const [loading, setLoading] = useState(false);
  const [BotId, setBotId] = useState("")
  const [bot, setBot] = useState(false);
  const [bots, setBots] = useState([]);
  const [preview, setPreview] = useState(false);
  const { toggleHelperId } = useModal();
  const textAreaRef = useRef(null);

  // const {
  //   toggleModal,
  // } = useModal();

  const loadCompanyData = async() => {
    setLoading(true);
    getRequest(
      `companieschannels/settings/chat?CompanyId=${companyData.id}`
      )
      .then((resp) => {
        setCode(resp.data.code)
        setDefaultColor(resp.data.defaultColor);
        setBackgroundColorChat(resp.data.backgroundColorChat)
        setBackgroundColorUserAnswer(resp.data.backgroundColorUserAnswer)
        setBackgroundColorCompanyAnswer(resp.data.backgroundColorCompanyAnswer);
        if(resp.data.BotId) {
          setBotId(resp.data.BotId);
          setBot(true);
        }
        getRequest(`/bots?companyId=${companyData.id}&onlyActive=1`)
        .then(function (response) {
          setBots(response.data);
          setLoading(false);
          }
        )
      })
  }

  useEffect(() => {
    loadCompanyData();
  }, [companyData]);

  const handleSave = () => {
    setLoading(true);

    putRequest(`companieschannels/settings/chat`, {
        CompanyId: companyData.id,
        defaultColor: defaultColor,
        backgroundColorChat: backgroundColorChat,
        backgroundColorUserAnswer: backgroundColorUserAnswer,
        backgroundColorCompanyAnswer: backgroundColorCompanyAnswer,
        BotId: BotId ? Number(BotId) : null
      })
      .then(function (request) {
        setLoading(false);
        handleGoBack();
      }
    )
  };

  useEffect(() => {
    if(bot === false) {
      setBotId('');
    }
  }, [bot]);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    toast.info(i18n.t('successCopy'));
  }

  useEffect(() => {
    toggleHelperId(24)
  }, [])

  return (
    
    <>
      <div style={{width: '70vw'}}>
        <div className="title-helper-container" style={{marginBottom: 10}}>
          <h3>{companyData.nickName}</h3>
        </div>
        {!preview ? 
        <>
            <h3>CHAT</h3>
          {!loading ? (
            <form
              className="form-edit"
              onSubmit={(e) => {
                e.preventDefault();
                handleSave();
              }}
            >
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label className="col-form-label">{i18n.t('implementCode')}</label>
                  <textarea
                    rows="5"
                    cols="200"
                    required
                    style={{resize: 'none'}}
                    disabled
                    ref={textAreaRef}
                    className="form-control"
                    defaultValue={code}
                  />
                  <button style={{top: 132}} type="button" className="copyButton" onClick={handleCopy}>
                    <i className="far fa-copy" style={{fontSize: 20}}></i>
                  </button>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="col-form-label">{i18n.t('standardColor')}</label>
                  <input
                    type="color"
                    required
                    className="form-control"
                    onChange={(value) => setDefaultColor(value.target.value)}
                    value={defaultColor}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label className="col-form-label">{i18n.t('backgroundColor')}</label>
                  <input
                    type="color"
                    required
                    className="form-control"
                    onChange={(value) => setBackgroundColorChat(value.target.value)}
                    value={backgroundColorChat}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="col-form-label">
                    {i18n.t('answerBoxColor')}
                  </label>
                  <input
                    type="color"
                    required
                    className="form-control"
                    onChange={(value) =>
                      setBackgroundColorUserAnswer(value.target.value)
                    }
                    value={backgroundColorUserAnswer}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label className="col-form-label">
                    {i18n.t('companyBoxColor')}
                  </label>
                  <input
                    type="color"
                    required
                    className="form-control"
                    onChange={(value) =>
                      setBackgroundColorCompanyAnswer(value.target.value)
                    }
                    value={backgroundColorCompanyAnswer}
                  />
                </div>
              </div>
              <div style={{marginTop: 10}}>
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>      
                    <input
                      type="checkbox"
                      checked={bot}
                      onChange={(value) => {
                        setBot(value.target.checked);
                      }}
                    />
                  <label style={{marginLeft: 5}} className="col-form-label">{i18n.t('attendanceBot')}</label>
                  </div>
                  {bot && 
                    <div className="form-bot">
                      <select 
                        className="select2 form-control select2-multiple"
                        style={{
                        width: 200,
                        }}
                        required={bot === true}
                        value={BotId || ''}
                        onChange={(e) => setBotId(e.target.value)}
                      >
                        {bots.length > 0 ? 
                          <>
                            <option value="">{i18n.t('chooseOne')}</option>
                              { bots.map(bot => {
                                return (
                                  <option key={bot.id} value={bot.id}>{bot.description}</option>
                                )
                              })}
                          </>
                        :
                          <option value="">{i18n.t('doesNotHaveBot')}</option>                  
                        }
                      </select>
                    </div>
                  }
                </div>
              <div
                className="button-list mt-3 pull-right"
                style={{ position: "absolute", bottom: 0, right: 0 }}
              >
                <button
                  type="button"
                  className="btn btn-outline-warning"
                  onClick={() => setPreview(true)}
                >
                  <i i className="mdi mdi-backup-restore"></i>
                  {i18n.t('preview')}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => handleGoBack()}
                >
                  <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('getBack')}
                </button>
                <button type="submit" className="btn btn-outline-success">
                  <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
                </button>
              </div>
            </form>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </>
        :
          <ChatPreview
            setPreview={setPreview}
            save={handleSave}
            defaultColor={defaultColor}
            backgroundColorChat={backgroundColorChat}
            backgroundColorUserAnswer={backgroundColorUserAnswer}
            backgroundColorCompanyAnswer={backgroundColorCompanyAnswer}

          />
        }
      </div>
    </>
  );
}
